import { ComplianceSteps } from 'src/app/interfaces/compliance-steps';
import { ModelDataType } from 'src/app/interfaces/model-data-type';
import { ViveProgressStatus } from 'src/app/interfaces/vive-progress-status';

import { BaseModel } from './base-model';
import { ClientRegisteredVendor } from './client-registered-vendor';
import { Company } from './company';
import { CompanyVendor } from './company-vendor';
import { Note } from './note';
import { User } from './user';
import { Vendor } from './vendor';

export class ViveProgress extends BaseModel {
  static override columnMap = new Map<
    string,
    { property: string; type: 'column'; dataType: ModelDataType }
  >();
  static override associationMap = new Map<
    string,
    { property: string; type: 'association'; model: string }
  >();
  static override aliasedColumnMap = new Map<
    string,
    { property: string; type: 'alias' }
  >();

  static ViveProgressProperties: (
    | {
        property: keyof ViveProgress;
        type: 'column';
        dataType: ModelDataType;
      }
    | {
        property: keyof ViveProgress;
        type: 'alias';
      }
    | {
        property: keyof ViveProgress;
        type: 'association';
        model: string;
      }
  )[] = [
    { property: 'id', type: 'column', dataType: 'number' },
    { property: 'CompanyVendorId', type: 'column', dataType: 'number' },

    { property: 'CompanyId', type: 'column', dataType: 'number' },
    { property: 'VendorId', type: 'column', dataType: 'number' },
    {
      property: 'ClientRegisteredVendorId',
      type: 'column',
      dataType: 'number'
    },
    { property: 'type', type: 'column', dataType: 'string' },
    { property: 'status', type: 'column', dataType: 'string' },
    { property: 'subStatus', type: 'column', dataType: 'string' },
    { property: 'statusDate', type: 'column', dataType: 'date' },
    { property: 'UserId', type: 'column', dataType: 'number' },
    { property: 'isOverrided', type: 'column', dataType: 'boolean' },
    { property: 'overrideDate', type: 'column', dataType: 'date' },
    { property: 'ticketUrl', type: 'column', dataType: 'string' },
    { property: 'CompanyId', type: 'column', dataType: 'number' },
    { property: 'createdAt', type: 'column', dataType: 'date' },
    { property: 'updatedAt', type: 'column', dataType: 'date' },

    { property: 'Vendor', model: 'Vendor', type: 'association' },
    { property: 'User', model: 'User', type: 'association' },
    { property: 'Company', model: 'Company', type: 'association' },
    {
      property: 'ClientRegisteredVendor',
      model: 'ClientRegisteredVendor',
      type: 'association'
    },
    { property: 'CompanyVendor', model: 'CompanyVendor', type: 'association' },
    { property: 'Notes', model: 'Note', type: 'association' }
  ];

  static {
    ViveProgress.ViveProgressProperties.forEach((propertyObject) => {
      const { property, type } = propertyObject;
      if (type === 'column') {
        ViveProgress.columnMap.set(property, propertyObject);
      }
      if (type === 'alias') {
        ViveProgress.aliasedColumnMap.set(
          property,
          propertyObject as { property: string; type: 'alias' }
        );
      }
      if (type === 'association') {
        ViveProgress.associationMap.set(
          property,
          propertyObject as {
            property: string;
            type: 'association';
            model: string;
          }
        );
      }
    });
  }

  constructor(ViveProgressObject: Partial<ViveProgress>) {
    super();

    ViveProgress.ViveProgressProperties.forEach((propertyObject) => {
      const { property } = propertyObject;
      const value = ViveProgressObject[property];
      if (value !== undefined) {
        Object.assign(this, { [property]: value });
      }
    });
  }

  id?: number;
  CompanyVendorId?: number | null;
  CompanyId?: number;
  VendorId?: number;
  ClientRegisteredVendorId?: number;
  UserId?: number;
  type?: ComplianceSteps;
  status?: ViveProgressStatus | null;
  statusDate?: Date;
  subStatus?:
    | 'All'
    | 'Partial'
    | 'Coverage Issues'
    | 'License'
    | 'License Issues'
    | 'Public Data'
    | 'Public Data Issues'
    | 'Compliance Summary'
    | 'Waived Findings'
    | 'VIVE Agreement Issue'
    | 'Vendor Agreement Issues'
    | 'W-9 Issue'
    | 'W-9 Issues'
    | 'Multiple'
    | 'Both'
    | 'No Licensed Trades';
  ticketUrl?: string;
  isOverrided?: boolean;
  overrideDate?: Date;
  createdAt?: Date;
  updatedAt?: Date;

  Vendor?: Vendor;
  User?: User;
  Company?: Company;
  ClientRegisteredVendor?: ClientRegisteredVendor;
  CompanyVendor?: CompanyVendor;
  Notes?: Note[];
}
